// ════════════════════════════════════════════════════════════════
//  hooks/useSocket.js
//  Hook singleton — une seule connexion socket pour toute l'app
//  Usage : const socket = useSocket();
// ════════════════════════════════════════════════════════════════
import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { API_URL } from '../Utils/api';

// Instance partagée entre tous les composants
let socketInstance = null;

const useSocket = () => {
  const [socket, setSocket] = useState(socketInstance);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    const token  = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');

    if (!token || !userId) return;

    // Réutilise la connexion existante si elle est active
    if (socketInstance?.connected) {
      setSocket(socketInstance);
      return;
    }

    // Crée une nouvelle connexion
    const SOCKET_URL = API_URL.replace('/api', '') || 'http://localhost:8000';

    socketInstance = io(SOCKET_URL, {
      query    : { t: userId },
      auth     : { userId },
      transports: ['websocket', 'polling'],
      reconnection      : true,
      reconnectionDelay : 1000,
      reconnectionAttempts: 5,
    });

    socketInstance.on('connect', () => {
      console.log('[Socket] Connecté :', socketInstance.id);
      // Enregistre le socketId côté serveur
      fetch(`${API_URL}/socket/getSocketId`, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer${token}` },
        body   : JSON.stringify({ socketId: socketInstance.id }),
      }).catch(console.error);
    });

    socketInstance.on('disconnect', () => {
      console.log('[Socket] Déconnecté');
      // Nettoie côté serveur
      fetch(`${API_URL}/socket/disconnect/getSocketId`, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ socketId: socketInstance.id }),
      }).catch(console.error);
    });

    socketInstance.on('connect_error', (err) => {
      console.error('[Socket] Erreur connexion:', err.message);
    });

    if (mountedRef.current) setSocket(socketInstance);

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return socket;
};

export default useSocket;